export default __webpack_public_path__ + "assets/Hamburger.68eb.svg";